"use strict";

import { matchResponsiveSize, openModalDialog } from "./common";
import { signOutAll } from "./auth";

export function toggleMobileMenuLevel(e) {
    const hasSubmenu = $(this).find('> ul');
    const isLinkToParentMenu = $(this).hasClass('super-menu__parent-menu');
    const isRootCategory = !!$(e.target).closest('.super-menu__root_category').length;
    const isSingleCategory = !!$(this).closest('.super-menu--single-category').length;
    // console.log('clicked', matchResponsiveSize(768), 'hasSubmenu', hasSubmenu.length);
    if (matchResponsiveSize(992, 'max')) {
        e.stopPropagation();

        // console.log('>>> clicked menu item',e, $(this), isRootCategory);

        if (isLinkToParentMenu) {
            if (isSingleCategory){
                $(this).closest('.header__main-menu-item').removeClass('active'); // skip 1 step
            } else {
                $(this).closest('ul').closest('li').removeClass('active');
            }
        } else {
            if (isRootCategory) {
                console.log('go to root category page');
                return;
            }

            if (hasSubmenu.length) {
                e.preventDefault();
                $(this).addClass('active');
                $(this).find('> ul').get(0).scrollIntoView();
            }
        }

        const mainMenu = $(this).closest('.header__main-menu');
            mainMenu.removeClass('header__main-menu--open-level-1 header__main-menu--open-level-2 header__main-menu--open-level-3')
            .addClass(`header__main-menu--open-level-${mainMenu.find('.active').length + 1}`);

    }
}

export function toggleMobileMenu(e, state) {
    const mainMenu = $('.header__main-menu');
    const currentState = mainMenu.hasClass('open');
    if (state === undefined) {
        state = !currentState;
    }
    mainMenu.toggleClass('open', state);
    $('.header__actions .menu .hamburger').toggleClass('is-active', state);
    $('body').toggleClass('mobile-menu-open', state);

    if (!state) {
        mainMenu.removeClass('header__main-menu--open-level-1 header__main-menu--open-level-2 header__main-menu--open-level-3');
        mainMenu.find('.active').removeClass('active');
    }
}

export function toggleProfileMenu(e, state) {
    const headerActionProfile = $('.header__actions .profile')
    const currentState = headerActionProfile.hasClass('open');
    const isSignedIn = headerActionProfile.hasClass('profile--signed-in');
    if (state === undefined) {
        state = !currentState;
    }
    if (isSignedIn && matchResponsiveSize(992, 'max')) {
        e.stopPropagation();
        e.preventDefault();
    }
    headerActionProfile.toggleClass('open', state);
}

export function toggleSearchMenuDesktop(e, state) {
    // const headerActionSearch = $('.header__actions .search')
    // const currentState = headerActionSearch.hasClass('open');
    // if (state === undefined) {
    //     state = !currentState;
    // }
    // headerActionSearch.toggleClass('open', state);
}

export default function init() {
    $('.header__main-menu').find(`
        .super-menu__root-menu,
        .super-menu__parent-menu, 
        .super-menu__filter-item, 
        .super-menu__category,
        .header__main-menu-item 
    `).on('click', toggleMobileMenuLevel);

    $('.header__actions .search .button').on('click', toggleSearchMenuDesktop);
    $('.header__actions .profile .button').on('click', toggleProfileMenu);
    $('.header__actions .menu .button').on('click', toggleMobileMenu);
}